import React from 'react';
import RecoverPasswordForm from './components/RecoverPasswordForm/index';
import LoginFooter from '../login/components/LoginFooter';
import style from './RecoverPassword.module.scss';

const RecoverPassword = () => (
  <div className={style.loginPageBackground}>
    <div className={style.loginPageFormContainer}>
      <RecoverPasswordForm />
    </div>
    <div className={style.loginPageFooter}>
      <LoginFooter />
    </div>
  </div>
);

export default RecoverPassword;
